
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function NeurogenicBladder(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Neurogenic Bladder"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Neurogenic bladder is <b>a problem in which a person lacks bladder control due to a brain,</b> spinal cord, or nerve condition.
                                </p>
                                <p><b>There are two types of neurogenic bladder. </b></p>
                                <p>Overactive bladder causes you to have little or no control over your
                                    urination. It can also cause you to feel a sudden or frequent need to
                                    urinate.</p>
                                <p>Underactive bladder occurs when your bladder muscles lose their
                                    ability to hold your urine.</p>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Neurogenic-bladder/1.png")} alt="Neurogenic-bladder" />
                                    </div>
                                </div>
                                <br></br>
                                <p><b>Symptoms</b></p>
                                <p><b>The most common symptom of neurogenic bladder is being unable to control
                                    urination. Other symptoms include:</b></p>
                                <p>A weak or dribbling urinary stream</p>
                                <p>Frequent urination (urinating eight or more times daily)</p>
                                <p>Urgency (a feeling or need to urinate immediately)</p>
                                <a className="links" href="https://en.wikipedia.org/wiki/Neurogenic_bladder_dysfunction">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default NeurogenicBladder;